import { styled, Button, Grid, lighten } from "@mui/material";

export const DeleteButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "top" && prop !== "marginLeft",
})<{ top: number; marginLeft: string }>(({ top, marginLeft, theme }) => ({
  width: "20px",
  height: "20px",
  position: "absolute",
  top,
  marginLeft,
  boxShadow: theme.shadows[2],
  backgroundColor: lighten(theme.palette.error.light, 0.85),
  padding: "12px",
  borderRadius: "5px 5px 0px 0px",
  zIndex: 1000,
}));

export const RectangleContentContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "marginLeft" && prop !== "width" && prop !== "height" && prop !== "top",
})<{ marginLeft: string; width: number; height: number; top: number }>(({ marginLeft, width, height, top }) => ({
  marginLeft,
  position: "absolute",
  top,
  width,
  height,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const TitleContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "top" && prop !== "marginLeft",
})<{ top: number; marginLeft: string }>(({ top, marginLeft, theme }) => ({
  fontSize: "10px",
  position: "absolute",
  top,
  marginLeft,
  // boxShadow: theme.shadows[2],
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: `5px 5px 0px 0px`,
}));
